
import apiRequest from "./apiRequest";

export const Mbp4RegisterApi = {

    fetchMbp4Register: (accountId, token) => {
    return apiRequest(`/api/register/mbp-4?accountId=${accountId}`, 'GET', token);
  },
  

  // Submit MGT-1 form data
  submitMbp4Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/mbp-4?accountId=${accountId}`, 'POST', token, formData);
  },

   addNewContracts: (id, payload, token) => {
        return apiRequest(
          `/api/register/mbp-4/contracts/${id}`,
          "POST",
          token,
          payload          // ← body is forwarded as-is to apiRequest
        );
      },


         addNewDirectorOfInterest: (id, payload, token) => {
        return apiRequest(
          `/api/register/mbp-4/director-interests/${id}`,
          "POST",
          token,
          payload          // ← body is forwarded as-is to apiRequest
        );
      },


};